import styled, { createGlobalStyle } from 'styled-components'
import BGImage from '../assets/background.jpg'

export const GlobalStyle = createGlobalStyle`

html{
  height: 100%
}

body {
  background-image: url(${BGImage});
  background-size: cover;
  margin: 0;
  padding: 0 20px;
  display: flex;
  justify-content: center;
}

*{
  box-sizing: border-box;
  font-family: 'Red Rose', cursive;
}
`
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column; 
  text-align: center;

  > p {
    color: #fff;
  }

  .score{
    font-size: 2rem;
    font-weight:900;
    color: black;
    font-size: 2rem;
    margin: 0 ;
  }

  h1 {
    font-family: 'Red Rose', cursive;
    background-image: linear-gradient(180deg, #fff, #87f1ff); 
    background-size: 100%;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-background-clip: text;
    -moz-text-fill-color: transparent;
    filter: drop-shadow(2px 2px #0085a3);
    font-size: 70px;
    font-weight: 400;
    text-align: center;
    margin: 20px
  }

  .start, .next, .level {
    cursor: pointer;
    background: linear-gradient(180deg, #fff, #ffcc91);
    border: 2px solid #d38558;
    box-shadow: 0px 5px 10px  rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    height: 40px;
    margin: 20px 0;
    padding: 0 40px
  }

  .start{
    max-width: 200px;
  }

  .level{
    display: block;
  }

  .level:focus{
    -webkit-background: linear-gradient(180deg, #fff, #14df2c);
    -webkit-tap-highlight-color: linear-gradient(180deg, #fff, #14df2c);
    -moz-background: linear-gradient(180deg, #fff, #14df2c);
    -o-background: linear-gradient(180deg, #fff, #14df2c);
    -ms-background: linear-gradient(180deg, #fff, #14df2c);
    background: linear-gradient(180deg, #fff, #14df2c);
  }

  .level-section{
    border: 2px solid black;  
    align-items: center;  
  }

  .instruction{
    color: black;
    font-size: 1.5rem;
    background: rgb(196,81,73);
  }
`